export function sendForm(form) {
  return new Promise((resolve, reject) => {
    // let token = document.querySelector('meta[name="_token"]').getAttribute("content");
    let xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    // xhr.setRequestHeader('X-CSRF-TOKEN', token);
    xhr.onerror = e => {
      reject(`Error: ${e.target.status} ${e.target.statusText}`);
    }
    xhr.onload = e => {
      if (e.target.status != 200) reject(`Error: ${e.target.status} ${e.target.statusText}`);
      resolve(e);
    }
    xhr.send(new FormData(form));
  });
}

export function getRules(form, rules = []) {
  [...document.querySelectorAll('[data-rules]')].forEach(
    el => rules.push({
      name: el.name,
      rules: el.getAttribute('data-rules')
    })
  );
  return rules;
}

export function showErrors(form, errors) {
  form.classList.add('has-errors');
  errors.forEach(err => err.element.closest('.field').classList.add('has-error'));
}

export function removeErrors(form) {
  form.classList.remove('has-errors');
  [...form.querySelectorAll('.has-error')].forEach(el => el.classList.remove('has-error'));
}




//////////////////
// WEBPACK FOOTER
// ./src/js/forms/helpers.js
// module id = 9
// module chunks = 0